import axiosInstance from '@/shared/api/axios';
import type {
  ApiReportsListParams,
  ApiReportsListResponse,
  ApiReportsPendingCountResponse,
  ApiServiceReport,
} from '@/shared/types/api/reports';

export const apiReportsList = async (
  params: ApiReportsListParams,
): Promise<ApiReportsListResponse> => {
  const { data } = await axiosInstance.get<ApiReportsListResponse>('/reports', { params });
  return data;
};

export const apiReportDone = async (id: number): Promise<ApiServiceReport> => {
  const { data } = await axiosInstance.post<ApiServiceReport>(`/reports/${id}/done`);
  return data;
};

export const apiReportCancel = async (id: number): Promise<ApiServiceReport> => {
  const { data } = await axiosInstance.post<ApiServiceReport>(`/reports/${id}/cancel`);
  return data;
};

export const apiReportsPendingCount = async (): Promise<ApiReportsPendingCountResponse> => {
  const { data } = await axiosInstance.get<ApiReportsPendingCountResponse>('/reports/pending-count');
  return data;
};
